function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Logger from '../../../../../wdh-foundation/wdh-logger/wdh-logger';
import { LocalStorageKeys } from './const';
var ApiProvider = /*#__PURE__*/function () {
  function ApiProvider() {
    _classCallCheck(this, ApiProvider);
  }
  return _createClass(ApiProvider, null, [{
    key: "getUrl",
    value: function getUrl(apiSelector) {
      if (apiSelector !== '#B2BOrdersApi') {
        // TODO: Should get info from Sitecore and switch based on apiSelector
        if (apiSelector === '#B2BCustomersApi') {
          return 'https://dgsus-dev-use-appservice-customers.azurewebsites.net/';
        } else if (apiSelector === '#GlobalApi') {
          return 'https://dev-shop-gateway-eur.ebiz.dgs.com/';
        }
      }
      var ordersApiSection = this.getJson('#B2BOrdersApi');
      var ordersApiUrl = ordersApiSection.ordersApi;
      if (localStorage && localStorage.getItem(LocalStorageKeys.OrdersUrl)) {
        ordersApiUrl = localStorage.getItem(LocalStorageKeys.OrdersUrl);
        Logger.info("Overwritten configuration for US Orders API: ".concat(ordersApiUrl));
      }
      if (ordersApiUrl.substring(ordersApiUrl.length - 1) !== '/') {
        ordersApiUrl += '/';
      }
      return ordersApiUrl;
    }
  }, {
    key: "getAuthorizationHeader",
    value: function getAuthorizationHeader() {
      var token = this.getToken();
      return "Bearer ".concat(token);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var sessionDetails = this.getJson('#B2BSessionDetails');
      return sessionDetails.token;
    }
  }, {
    key: "getJson",
    value: function getJson(selector) {
      var text = $(selector).text();
      var json = JSON.parse(text);
      return json;
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      var configuration = JSON.parse($('#B2BSessionDetails').text());
      return configuration.currentlanguage;
    }
  }]);
}();
export default ApiProvider;